import {Component} from '@angular/core';
import {AuthenticationService} from '@services/authentification.service';
import * as $ from 'jquery';
import {DeviceDetectorService} from 'ngx-device-detector';
import {UserService} from '@services/user.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: []
})
export class AppComponent {
    title = 'LyBox';
    ready = false;

    constructor(
        public authenticationService: AuthenticationService,
        public userService: UserService,
        public deviceService: DeviceDetectorService,
    ) {
        authenticationService.loadUser().subscribe(() => {
            this.ready = true;
        });

        $(document).ready(() => {
            $(document).on('click', '.collapseBtn', function() {
                $('app-sidebar').toggleClass('collapsed');
                $('#content').toggleClass('extended');
                if (authenticationService.isLogin) {
                    authenticationService.currentUser.user_dashboard.sidebar_collapse = $('app-sidebar').hasClass('collapsed');
                    userService.updateDashboard(authenticationService.currentUser);
                }
            });

            $(document).on('click', 'ul li.isMinimizable .cta_min', function() {
                $(this).parent('li').toggleClass('minimize');
            });

            $(document).on('click', '.card.isMinimizable .card-header', function() {
                $(this).parent('.card').toggleClass('minimize');
                $(this).parent().parent('.card').toggleClass('minimize');
            });

            $(document).on('click', 'td.isMinimizable', function() {
                if ($(this).hasClass('minimize')) {
                    $('.' + $(this).attr('data-target')).show();
                } else {
                    $('.' + $(this).attr('data-target')).hide();
                }
                $(this).toggleClass('minimize');
            });
        });

    }
}
